// Components
import { SvgIcon, Tooltip } from "@mui/material";
import clsx from "clsx";
import { PlusCircle } from "react-feather";

// Hooks
import { useScenarioCardStyles } from "src/views/marketing-actions/components/form/ScenarioCard/ScenarioCard.styles";

interface SpacerDisplayProps {
    background?: boolean;
    hideButton?: boolean;
    handleOpenDialogCreate: () => void;
    isDisabled?: boolean;
    tooltipText?: string;
}
export function SpacerDisplay({
    background,
    hideButton,
    handleOpenDialogCreate,
    isDisabled = false,
    tooltipText = "",
}: SpacerDisplayProps): JSX.Element {
    const classes = useScenarioCardStyles();

    return (
        <div className={clsx(classes.spacerContainer, { [classes.stripesBackground]: background })}>
            <Tooltip title={tooltipText}>
                <div>
                    {hideButton !== true && (
                        <SvgIcon
                            fontSize="small"
                            className={
                                isDisabled
                                    ? classes.SpacerDisplayButtonDisabled
                                    : classes.SpacerDisplayButton
                            }
                            onClick={handleOpenDialogCreate}
                        >
                            <PlusCircle />
                        </SvgIcon>
                    )}
                </div>
            </Tooltip>
        </div>
    );
}
